<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">




    <div class="col-6 mt-3"> 


          <!-- Button trigger modal -->
<button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==3" type="button" class="btn btn-success" @click="addinternalcorrespondence()" data-bs-toggle="modal" data-bs-target="#exampleModal">
 დამატება
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      
        <div class="mb-3 mt-3">
  
  <input type="text" class="form-control" placeholder=" ადრესატი"  v-model="addressee">
 
</div>
<div class="mb-3">

  <input type="text" class="form-control"  placeholder="ხელმომწერი" v-model="signatory">
</div>

  <div class="mb-3">

    <textarea rows="2" cols="50" name="comment" form="usrform" class="form-control" placeholder="შინაარსი" v-model="description">
</textarea>
 
</div>
<!-- <div class="mb-3">
<p>თარიღი</p>
<input type="date" class="form-control" v-model="internalcorrespondence_date">

</div> -->
<div class="mb-3">

  <input type="file" class="form-control" @change="getinternalcorrespondence_file">

</div>
        
        


      </div>
      <div class="modal-footer">
        <button v-if="!isReadyForEdit" type="button" class="btn btn-success" @click="savecorr()">შენახვა</button>
        <button v-else type="button" class="btn btn-success" @click="goEditinternalCorrespondence(editedCorrespondenceID)">რედაქტირება</button>
      
      </div>
    </div>
  </div>
</div>
 
           
         
        </div> 
        
             <div class="col-12 mt-3">

                   <div class="row justify-content-center">
                  <div class="col-4 mb-2 d-grid" v-for="years of internalCorrespondenceYears">
                    <button @click="showInternalCorrespondence(years.internalCorrespondenceYear)" class="btn btn-success">{{ years.internalCorrespondenceYear }}</button>
                  </div>
              </div>

                 <table class="table" v-if="correspondences.length>0">
   <thead>
     <tr>
     
      
       <th scope="col"> ადრესატი</th>
       <th scope="col">ხელმომწერი</th>
       <th scope="col">შინაარსი</th>
       <th scope="col">დაწერის თარიღი</th>
       <th scope="col">მიმაგრებული ფაილი</th>
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="internalcorrespondence in correspondences" :key='internalcorrespondence.internalcorrespondenceID'>
     
   
        
     
       <td>{{internalcorrespondence.addressee }}</td>
       <td>{{internalcorrespondence.signatory }}</td>
       <td>{{internalcorrespondence.description }}</td>
       <td>{{internalcorrespondence.internalcorrespondence_date }}</td>
       <td><a :href="'https://api.ugcollege.ug.edu.ge/storage/internalcorrespondence/'+internalcorrespondence.internalcorrespondence_file" target="_blank">მიმაგრებული ფაილი</a></td>

       <td><button v-if="this.$store.state.user.positionID==1"  type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editinternalCorrespondece(internalcorrespondence)"><i class='bx bxs-edit-alt'></i></button> </td>
       <td> <button v-if="this.$store.state.user.positionID==1"  type="button" class="btn btn-outline-success" @click="deleteinternalCorrespondence(internalcorrespondence.internalcorrespondenceID)"><i class='bx bx-x'></i></button></td>
    
    
     </tr>
   
   
  
 
   </tbody>
 </table>
             </div>
 
     </div>
    </div>
  
 
 </template>
 <script>
import HttpRequests from '../httpRequests/httpRequests'
const httpRequests=new HttpRequests()
 export default{
 
   data(){
 return{
  addressee:null,
  signatory:null,
  description:null,
  internalcorrespondence_date:null,
  internalcorrespondence_file:null,
  correspondences:[],
  isReadyForEdit:false,
  editedCorrespondenceID:0,
  internalCorrespondenceYears:[]

 }

   },
   mounted(){

    httpRequests.getInternalCorrespondenceYears().then(response=>{
      this.internalCorrespondenceYears=response.data
    })
    
   },
   methods:{

    showInternalCorrespondence(year){
httpRequests.getinternalCorrespondence(year).then(response=>{
      
      this.correspondences=this.enumerateRowsByYear(response.data)
    })
    },

enumerateRowsByYear(data) { 

   // Step 1: Process in reverse (oldest to newest)
  const reversed = [...data].reverse();
  let currentYear = null;
  let counter = 0;

  const processed = reversed.map(row => {
    const year = new Date(row.internalcorrespondence_date).getFullYear();
    if (year !== currentYear) {
      currentYear = year;
      counter = 1;
    } else {
      counter++;
    }
    return { ...row, row_number: counter };
  });

  // Step 2: Reverse back to original (newest to oldest)
  return processed.reverse();
},




    getinternalcorrespondence_file(e){
      this.internalcorrespondence_file=e.target.files[0]
    },
    savecorr(){
      let formData=new FormData()
      formData.append('addressee',this.addressee)
      formData.append('signatory', this.signatory)
      formData.append('description', this.description)
      formData.append('internalcorrespondence_date', this.internalcorrespondence_date)
      formData.append('internalcorrespondence_file', this.internalcorrespondence_file)
      httpRequests.savecorr(formData).then(()=>{
        location.reload()

      })


    },
    goEditinternalCorrespondence(internalcorrespondenceID){
      let formData=new FormData()
      formData.append('addressee',this.addressee)
      formData.append('signatory', this.signatory)
      formData.append('description', this.description)
      formData.append('internalcorrespondence_date', this.internalcorrespondence_date)
      formData.append('internalcorrespondence_file', this.internalcorrespondence_file)
      formData.append('internalcorrespondenceID',internalcorrespondenceID)

      httpRequests.goEditinternalCorrespondence(formData).then(()=>{
        location.reload()

      })


    },

    editinternalCorrespondece(internalcorrespondence){
      this.isReadyForEdit=true
        this.editedCorrespondenceID=internalcorrespondence.internalcorrespondenceID 
        this.addressee=internalcorrespondence.addressee
        this.signatory=internalcorrespondence.signatory
        this.description=internalcorrespondence.description
        this.internalcorrespondence_date=internalcorrespondence.internalcorrespondence_date
       
      },
      addinternalcorrespondence(){

this.isReadyForEdit=false
    this.editedCorrespondenceID=0
    this.addressee=null
    this.signatory=null
    this.description=null
    this.internalcorrespondence_date=null

},

deleteinternalCorrespondence(internalcorrespondenceID){

if(confirm("ნამდვილად გსურთ წაშლა?")){
  httpRequests.deleteinternalCorrespondence(internalcorrespondenceID).then(()=>{
    location.reload()
  })
}

}
   }



  }


</script>